export type BreadcrumbItem = {
  label: string
  href: string
  isCurrent: boolean
}

const decodePathSegment = (segment: string): string => {
  try {
    return decodeURIComponent(segment)
  } catch {
    return segment
  }
}

const pathnameFrom = (value: unknown): string => {
  const raw = String(value ?? '').trim()
  if (!raw) return '/'

  try {
    return new URL(raw, 'https://cms.local').pathname
  } catch {
    return (raw.split('#')[0] || '').split('?')[0] || '/'
  }
}

const canonicalSegments = (value: unknown): string[] => {
  const segments = pathnameFrom(value).split('/').filter(Boolean)
  const lastIndex = segments.length - 1
  const hasTrailingPagination = lastIndex >= 1
    && segments[lastIndex - 1] === 'page'
    && /^\d+$/.test(segments[lastIndex] || '')

  return hasTrailingPagination ? segments.slice(0, -2) : segments
}

export const buildBreadcrumbItems = (path: unknown): BreadcrumbItem[] => {
  const segments = canonicalSegments(path)
  const items: BreadcrumbItem[] = [{
    label: 'Home',
    href: '/',
    isCurrent: segments.length === 0,
  }]

  segments.forEach((segment, index) => {
    items.push({
      label: decodePathSegment(segment),
      href: `/${segments.slice(0, index + 1).join('/')}`,
      isCurrent: index === segments.length - 1,
    })
  })

  return items
}